module.exports = __webpack_public_path__ + "img/high-bandwidth.02bdf4c.png";